import "./OtpVerification.scss";
import "react-phone-number-input/style.css";
import { Field, Form, Formik } from "formik";
import * as yup from "yup";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { setLanguage } from "../../../Services/Redux/Reducer/Reducer";
import {
  ERROR_MESSAGES,
  REGEX,
} from "../../../Utilities/Constants/Validations";
import { axiosInstance } from "../../../Services/Interceptor/Interceptor";
import API_END_POINTS from "../../../Utilities/Constants/ApiEndpoints";
import LanguageIcon from "@mui/icons-material/Language";
import {
  TOASTER_CONFIGS,
  API_RESPONSE,
  LANGUAGES,
  LAYOUTS,
  ROUTES,
  AUTHENTICATION_LABELS,
  TUTOR_REGISTRATION_FIELDS,
  TUTOR_TYPE,
  STORAGE_KEYS,
  TOKENS,
  I18_TRANSLATION_COMMON,
  NUMBER_CONSTANTS,
  VALIDATION_CONSTANT,
} from "../../../Utilities/Constants/Constants";
import { useNavigate } from "react-router";
import PhoneInput from "react-phone-number-input";
import passwordVisible from "../../../../Assets/Login/password_visible.svg";
import passwordInvisible from "../../../../Assets/Login/password_invisible.svg";
import { toast } from "react-toastify";
import { useEffect, useState } from "react";
import {
  GetSessionStorageData,
  SetSessionStorageData,
  applyUserBasedTheme,
  clearSessionKey,
} from "../../../Services/Helpers/Helper";
import OtpInput from "react-otp-input";
import { useTimer } from "react-timer-hook";
import editImage from "../../../../Assets/Login/edit-otp.svg";
import loginBanner from "../../../../Assets/Registration/signup_banner.svg";

const OtpVerification = () => {
  const { t, i18n } = useTranslation(I18_TRANSLATION_COMMON.COMMON);
  /**email state */
  const [email, setEmail] = useState(GetSessionStorageData(STORAGE_KEYS.EMAIL));
  /* Resend OTP button visibility states**/
  const [showResend, setShowResend] = useState(API_RESPONSE.FALSE);
  /**OTP states */
  const [otp, setOtp] = useState("");
  const [otpExpired, setOtpExpired] = useState(API_RESPONSE.FALSE);
  const [phoneNumber, setPhoneNumber]: any = useState("");
  const [loginType, setLoginType]: any = useState("");
  /**Time state */
  const time = new Date();
  time.setSeconds(time.getSeconds() + NUMBER_CONSTANTS.ONE_TWENTY);
  /**Timer hook */
  const { seconds, minutes, restart } = useTimer({
    expiryTimestamp: time,
    autoStart: API_RESPONSE.TRUE,
    onExpire: () => { setShowResend(API_RESPONSE.TRUE); SetSessionStorageData(STORAGE_KEYS.OTP_EXPIRED, API_RESPONSE.TRUE); setOtpExpired(API_RESPONSE.TRUE) },
  });

  useEffect(() => {
    let expKey = GetSessionStorageData(STORAGE_KEYS.OTP_EXPIRED);
    expKey ? setOtpExpired(API_RESPONSE.TRUE) : setOtpExpired(API_RESPONSE.FALSE);
  })
  useEffect(() => {
    setEmail(GetSessionStorageData(STORAGE_KEYS.EMAIL));
    setPhoneNumber(GetSessionStorageData(STORAGE_KEYS.PHONE_NUMBER));
    setLoginType(GetSessionStorageData(STORAGE_KEYS.LOGIN_TYPE));
  }, [])

  /* Navigatoin hook**/
  const navigate = useNavigate();
  /* Toggle language**/
  const changeLanguage = (languageCode: string) => {
    dispatch(
      setLanguage(
        language === LANGUAGES.ENGLISH ? LANGUAGES.ARABIC : LANGUAGES.ENGLISH
      )
    );
    i18n.changeLanguage(languageCode);
  };
  /* set and get language from redux**/
  const dispatch = useDispatch();
  const language: any = useSelector((state: any) => {
    return state.languageReducer.language;
  });

  /**register payload */
  const getVerifyOtpPayload = () => {
    if (loginType === `${NUMBER_CONSTANTS.ONE}`) {
      return { email: email, otp: otp }
    } else {
      return { phone_number: phoneNumber, otp: otp }
    }


  };

  const loggedFirstTime = () => {
    axiosInstance.put(API_END_POINTS.FIRST_LOGIN).then((response: any) => {

    })
  }

  /* Handling tokens */
  const responseAction = (response: any) => {
    return new Promise((resolve, reject) => {
      if (response.data[API_RESPONSE.STATUS] === API_RESPONSE.TRUE) {
        clearSessionKey(STORAGE_KEYS.OTP_EXPIRED);
        SetSessionStorageData(STORAGE_KEYS.ID, response.data.result.data.user_info.id);
        if (response.data.result.data.is_registered) {
          SetSessionStorageData(
            TOKENS.ACCESS_TOKEN,
            response.data.result.data.access_token
          );
          SetSessionStorageData(STORAGE_KEYS.ROLE, response.data.result.data.role);
          if (response.data.result.data.is_approved === API_RESPONSE.FALSE) {
            navigate(ROUTES.ONBOARDING_SCREEN, { state: { is_rejected: response.data?.result.data?.is_rejected } });
            applyUserBasedTheme();
          } else if (response.data.result.data.is_approved === API_RESPONSE.TRUE && response.data.result.data.is_first_login === API_RESPONSE.TRUE) {
            navigate(ROUTES.WELCOME_SCREEN);
            applyUserBasedTheme();
            loggedFirstTime();
          } else if (response.data.result.data.is_approved === API_RESPONSE.TRUE && response.data.result.data.is_first_login === API_RESPONSE.FALSE) {
            navigate(ROUTES.DASHBOARD);
            applyUserBasedTheme()
          }


        } else {
          SetSessionStorageData(
            TOKENS.TEMPORARY_TOKEN,
            response.data.result.data.access_token
          );

          SetSessionStorageData(STORAGE_KEYS.ROLE, response.data.result.data.role)
          SetSessionStorageData(STORAGE_KEYS.ACTIVE_STEP, (response.data.result.data.screen_number + 1))
          navigate(ROUTES.REGISTER_SP);
        }
        SetSessionStorageData(
          TOKENS.REFRESH_TOKEN,
          response.data.result.data.refresh_token
        );
        //navigate(ROUTES.DASHBOARD);
        toast.success(response.data.message, TOASTER_CONFIGS);
        resolve(true);
      }
    })
  }

  /* Verify OTP API call */
  const signupOtpVerify = () => {
    axiosInstance
      .post(API_END_POINTS.VERIFY_OTP + `?${STORAGE_KEYS.LOGIN_TYPE}=` + loginType, getVerifyOtpPayload())
      .then((response: any) => {
        if (response.data[API_RESPONSE.STATUS] === API_RESPONSE.TRUE) {
          SetSessionStorageData(STORAGE_KEYS.ID, response.data.result.data.id);
          navigate(ROUTES.REGISTER_SP);
        }

        /*  responseAction(response).then(response=>{
           navigate(ROUTES.REGISTER_SP)
         }) */
      })
      .catch((error: any) => { });
  };

  /* Verify OTP API call */
  const loginOtpVerify = () => {
    axiosInstance
      .post(API_END_POINTS.VERIFY_LOGIN_OTP + `?${STORAGE_KEYS.LOGIN_TYPE}=` + loginType, getVerifyOtpPayload())
      .then((response: any) => {
        responseAction(response).then(response => {
          // navigate(ROUTES.DASHBOARD)
        })
      })
      .catch((error: any) => { });
  }

  /* login API call **/
  const verify = () => {
    if (otp.length === NUMBER_CONSTANTS.FOUR) {
      GetSessionStorageData(STORAGE_KEYS.MODE) === AUTHENTICATION_LABELS.SIGN_UP ? signupOtpVerify() : loginOtpVerify();
    }/* else{
      toast.success(ERROR_MESSAGES.OTP_MESSAGE, TOASTER_CONFIGS);
    } */

  };

  const getResendOTPPayload = () => {
    return loginType === `${NUMBER_CONSTANTS.ONE}` ?
      {
        email: email,
        roles: `${NUMBER_CONSTANTS.FOUR}`,
      }
      :
      {
        phone_number: phoneNumber,
        roles: `${NUMBER_CONSTANTS.FOUR}`,
      }

  }

  const loginResendOTP = () => {

    axiosInstance
      .post(
        API_END_POINTS.LOGIN_API + `?${STORAGE_KEYS.LOGIN_TYPE}=` + loginType,
        getResendOTPPayload()
      )
      .then((response: any) => {
        if (response.data.status === API_RESPONSE.TRUE) {
          toast.success(response.data.message, TOASTER_CONFIGS);
        }
      })
      .catch(() => { });
  };

  const signupResendOTP = () => {

    axiosInstance.post(API_END_POINTS.CREATE_ACCOUNT + `?${STORAGE_KEYS.LOGIN_TYPE}=` + loginType, getResendOTPPayload()).then((response: any) => {
      if (response.data.status === API_RESPONSE.TRUE) {
        toast.success(response.data.message, TOASTER_CONFIGS);
      }
    })
  }

  /**Resend OTP */
  const resendOtp = () => {
    GetSessionStorageData(STORAGE_KEYS.MODE) === AUTHENTICATION_LABELS.SIGN_UP ? signupResendOTP() : loginResendOTP();
  };
  return (
    <div
      className="row otp-wrapper"
      dir={language === LANGUAGES.ENGLISH ? LAYOUTS.LTR : LAYOUTS.RTL}
    >
      <div className="col-md-6 logo-contents">
        <img className="login-banner" src={loginBanner} />
      </div>
      <div
        className={
          language === LANGUAGES.ENGLISH ? "col-md-6 column-wrap" : "col-md-6 column-wrap-rtl"
        }
      >
        <div className="row language_switch_header">
          <div className="language_switch_contianer">
            <LanguageIcon className="language_icon" />
            <button
              className="language_button"
              onClick={() => {
                changeLanguage(
                  language === LANGUAGES.ENGLISH
                    ? LANGUAGES.ARABIC_ABBRIVATION
                    : LANGUAGES.ENGLISH_ABBRIVATION
                );
              }}
            >
              {language === LANGUAGES.ENGLISH
                ? LANGUAGES.ARABIC
                : LANGUAGES.ENGLISH}
            </button>
          </div>
        </div>

        <div className="form-wrapup">
          <div className="form-contents">
            <h2 className="form-heading">{t('OTP Verification')}</h2>

            <p className="otp-text">
              {t(
                `Please check your inbox for the OTP email sent to`
              )}
            </p>
            <span className="phone_number">{loginType === `${NUMBER_CONSTANTS.ONE}` ? email : phoneNumber}</span>
            <img className="edit-image" src={editImage} onClick={() => { navigate(ROUTES.SIGN_UP) }} />
            <OtpInput
              value={otp}
              onChange={setOtp}

              numInputs={4}
              containerStyle="otp_container"
              inputStyle="input_container"
              renderSeparator={<span>-</span>}
              shouldAutoFocus={true}
              renderInput={(props, index) => (
                <input key={index} {...props} onKeyPress={(event: any) => {
                  if (event.key === VALIDATION_CONSTANT.KEY_TYPE) {
                    verify()
                  }
                }} />
              )}
            />
            {/* <div className="timer_container">
                  <span>{minutes}</span>:<span>{seconds}</span>
                </div> */}
            {/* {showResend && (
                  <div className="reset_wrapper">
                    {t("Didn't receive the OTP!")}
                    <button
                      onClick={resendOtp}
                      className="reset_button"
                      type="button"
                    >
                      {t("Resend")}
                    </button>
                  </div>
                )} */}


            <div className="alternative-btn-wrap">
              <button className={otp.length === 4 ? "btn alternative-btn" : "btn alternative-btn-inactive"} onClick={verify} >
                {t('Continue')}
              </button>
            </div>

            {(showResend || otpExpired) && <div className="resend-otp">
              <p>{t('Don’t receive OTP?')} <span className="resend-text" onClick={resendOtp}>{t('Resend OTP')}</span></p>
            </div>}
            {(!showResend && !otpExpired) && <div className="resend-otp">
              <p>{t('OTP Expries in')} <span className="resend-text" onClick={resendOtp}>{minutes + ':' + `${seconds < 10 ? ('0' + seconds) : seconds}`} minutes</span></p>
            </div>}
          </div>
        </div>
      </div>
    </div>




  );
};

export default OtpVerification;